module.exports = __webpack_public_path__ + "b533fa09e844097442af8164a5ed6335.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-bank.png
// module id = 828
// module chunks = 0